import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ContactContent extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            loading : 1,
            settings:{},
            name:'',
            email:'',
            message:'',
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:""
            
        }
        

    }

    handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (!this.state.name) {
            errors.name = 'Name is required';
          }  
          if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
        
        if (!this.state.message) {
            errors.message = 'Message is required';
          } 
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
          
             
            var data = {  name:this.state.name, 'email' :this.state.email, 'message':this.state.message  }
            axios.post(api_base_url+"send_contact", data).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message});  
                }
                else{
                    
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Enquiry Successfully Sent."});
                    this.setState({name:''});
                    this.setState({email:''});
                    this.setState({message:''});
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

    componentDidMount()
    {
        axios.get(api_base_url+"settings").then(response=>{
            this.setState({settings:response.data}) ;
        });
    }


    render()
    { 
        
    return (
         
           <div>
 <section class="ul-contact-infos">
             
            <div class="ul-contact-info">
                <div class="icon"><i class="flaticon-location"></i></div>
                <div class="txt">
                    <h6 class="title">Our Address</h6>
                    <p class="descr mb-0">{this.state.settings.contact_contact_address} </p>
                </div>
            </div>

             
            <div class="ul-contact-info">
                <div class="icon"><i class="flaticon-email"></i></div>
                <div class="txt">
                    <h6 class="title">Email Address</h6>
                    <p class="descr mb-0">
                        <a href={"mailto:"+this.state.settings.contact_email}>{this.state.settings.contact_email}</a>
                       
                    </p>
                </div>
            </div>

             
            <div class="ul-contact-info">
                <div class="icon"><i class="flaticon-stop-watch-1"></i></div>
                <div class="txt">
                    <h6 class="title">Contact Numbers</h6>
                    <p class="descr mb-0">
                        <span><Link href={"tel: "+this.state.settings.contact_mobile_number1} > {this.state.settings.contact_phone_number}</Link></span><br /> 
                    </p>
                </div>
            </div>
        </section>
        


        
       {/*** <div class="ul-contact-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8684.030842913655!2d90.36627512368048!3d23.776418440774698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8f3f608843b%3A0xf2c71ff392721324!2sLiberation%20War%20Museum!5e0!3m2!1sen!2sbd!4v1730028096808!5m2!1sen!2sbd" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
          */}

        <div class="ul-contact-from-section">
            <div class="ul-contact-form-container">
                <h3 class="ul-contact-form-container__title">Get in Touch</h3>
                <form action="#" class="ul-contact-form">
                    <div class="grid">
                         
                        <div class="form-group">
                            <div class="position-relative">
                                <input type="text" name="name" placeholder="Your Name"  id="name"  
                                        required="" onChange={this.handleChange} value={this.state.name} />
                                <span class="field-icon"><i class="flaticon-user"></i></span>
                               
                            </div> {this.state.errors.name && <label className="error">{this.state.errors.name}</label>}
                        </div>
  
                        <div class="form-group">
                            <div class="position-relative">
                                <input type="email" name="email" placeholder="Email Address"  id="email"  
                                        required="" onChange={this.handleChange} value={this.state.email} />
                                <span class="field-icon"><i class="flaticon-email"></i></span>
                            </div>       
                                                     {this.state.errors.email && <label className="error">{this.state.errors.email}</label>}

                        </div>
                         
                        <div class="form-group">
                            <div class="position-relative">
                                <textarea name="message" placeholder="Write Message . ."  id="message"  
                                        required="" onChange={this.handleChange} value={this.state.message}></textarea>
                                <span class="field-icon"><i class="flaticon-edit"></i></span>
                            </div>
                              {this.state.errors.message && <label className="error">{this.state.errors.message}</label>}
                        </div>
                    </div>
                     
                    <button type="button" onClick={this.handleSubmit}>Send Message</button>
                </form>
                <div className='alert alert-success '  id={this.state.fopen ? "dblock" : "dnone"}>{this.state.success_message}</div>
                        
                                <div className='alert alert-warning '  id={this.state.reg_error ? "dblock" : "dnone"}>{this.state.err_message}</div>
            </div>
        </div>
           </div>
            
    );
}

}

export default ContactContent;